/**
 * Which greeting fits right now, by the device's own clock — so "Good evening" in Seattle
 * at 8 pm without asking where the person is (QA note, 2026-09-09).
 */
export type DayPart = 'morning' | 'afternoon' | 'evening';

/** Local hours at which the greeting changes: morning from 5, afternoon from noon, evening from 6 pm. */
const FIRST_BOUNDARY = { hour: 5, part: 'morning' } as const;
const BOUNDARIES: ReadonlyArray<{ hour: number; part: DayPart }> = [
  FIRST_BOUNDARY,
  { hour: 12, part: 'afternoon' },
  { hour: 18, part: 'evening' },
];

/** The part of the day at `now`, in the device's time zone. The small hours count as evening. */
export function dayPart(now: Date): DayPart {
  const hour = now.getHours();
  let part: DayPart = 'evening';
  for (const boundary of BOUNDARIES) {
    if (hour >= boundary.hour) part = boundary.part;
  }
  return part;
}

/** Milliseconds from `now` until the day part next changes, so an open Home can re-greet. */
export function msUntilNextDayPart(now: Date): number {
  const next = new Date(now);
  next.setSeconds(0, 0);
  const upcoming = BOUNDARIES.find((boundary) => boundary.hour > now.getHours());
  if (upcoming) {
    next.setHours(upcoming.hour, 0);
  } else {
    next.setDate(next.getDate() + 1);
    next.setHours(FIRST_BOUNDARY.hour, 0);
  }
  return next.getTime() - now.getTime();
}
